import React, { useEffect, useState, useCallback, useRef } from 'react';
import api from '../../api/client';
import { MESI, eur, dataIt, inputS, labelS, btnPri, btnSec, card, th, td, pillS, statoLabel, leggiFile, apriPdf } from './shared';

const oggi = new Date();
const vuoto = () => ({ id: null, anno: oggi.getFullYear(), mese: oggi.getMonth() + 1, data_spesa: oggi.toISOString().slice(0, 10), categoria: '', dettaglio: '', importo: '', file: null });

export default function RimborsiAllenatore() {
  const [dati, setDati]     = useState(null);
  const [form, setForm]     = useState(vuoto());
  const [aperto, setAperto] = useState(false);
  const [err, setErr]       = useState('');
  const [invio, setInvio]   = useState(false);
  const [msg, setMsg]       = useState('');
  const fileRef = useRef(null);

  const load = useCallback(async (anno, mese) => {
    const r = await api.get(`/rimborsi/me?anno=${anno}&mese=${mese}`);
    setDati(r.data);
  }, []);
  useEffect(() => { load(form.anno, form.mese).catch(e => setErr(e.response?.data?.error || 'Errore nel caricamento')); }, [form.anno, form.mese, load]);

  const mesiOpzioni = (() => { // mese corrente e i 3 precedenti
    const out = [];
    for (let i = 0; i < 4; i++) { const d = new Date(oggi.getFullYear(), oggi.getMonth() - i, 1); out.push({ anno: d.getFullYear(), mese: d.getMonth() + 1 }); }
    return out;
  })();

  const importoNum = parseFloat(String(form.importo).replace(',', '.')) || 0;
  // In modifica la richiesta stessa è già conteggiata nel tetto usato del mese
  const propria = form.id ? (dati?.richieste.find(r => r.id === form.id && r.anno === form.anno && r.mese === form.mese && r.stato !== 'RIFIUTATO')?.importo || 0) : 0;
  const residuo = dati ? dati.residuo + propria : 0;
  const dopo = residuo - importoNum;
  const tetto = dati?.tetto || 300;

  const scegliFile = (f) => {
    if (!f) return setForm(s => ({ ...s, file: null }));
    if (!['application/pdf', 'image/jpeg', 'image/png'].includes(f.type)) { setErr('Formato non valido: sono ammessi solo PDF, JPG e PNG'); return; }
    if (f.size > (dati?.max_mb || 8) * 1024 * 1024) { setErr(`File troppo grande: massimo ${dati?.max_mb || 8} MB`); return; }
    setErr(''); setForm(s => ({ ...s, file: f }));
  };

  const invia = async (e) => {
    e.preventDefault(); setErr('');
    if (!form.file && !form.id) return setErr('Carica il giustificativo');
    setInvio(true);
    try {
      const payload = { anno: form.anno, mese: form.mese, data_spesa: form.data_spesa, categoria: form.categoria, dettaglio: form.dettaglio, importo: form.importo };
      if (form.file) payload.allegato = await leggiFile(form.file);
      if (form.id) await api.put(`/rimborsi/me/${form.id}`, payload); else await api.post('/rimborsi/me', payload);
      setMsg(form.id ? 'Richiesta rinviata!' : 'Richiesta inviata!'); setTimeout(() => setMsg(''), 3000);
      setForm(vuoto()); setAperto(false); if (fileRef.current) fileRef.current.value = '';
      load(form.anno, form.mese);
    } catch (e2) { setErr(e2.response?.data?.error || e2.message || 'Errore nell\'invio'); }
    finally { setInvio(false); }
  };

  const modifica = (r) => {
    setForm({ id: r.id, anno: r.anno, mese: r.mese, data_spesa: r.data_spesa.slice(0, 10), categoria: r.categoria, dettaglio: r.dettaglio, importo: String(r.importo).replace('.', ','), file: null });
    setErr(''); setAperto(true); window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const ritira = async (r) => {
    if (!window.confirm(`Ritirare la richiesta ${r.numero}?`)) return;
    try { await api.delete(`/rimborsi/me/${r.id}`); load(form.anno, form.mese); } catch (e) { alert(e.response?.data?.error || 'Errore'); }
  };

  if (!dati) return <div style={{ color:'var(--text-dim)' }}>{err || 'Caricamento…'}</div>;
  const pct = (n) => `${Math.min(100, (n / tetto) * 100)}%`;
  const eccede = dopo < -0.001;

  return (
    <div style={{ maxWidth:'1000px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:'12px', flexWrap:'wrap', marginBottom:'18px' }}>
        <h2 style={{ fontFamily:"'Barlow Condensed'", fontSize:'var(--font-size-xl)', fontWeight:'700', letterSpacing:'2px', margin:0 }}>I MIEI RIMBORSI</h2>
        {!aperto && <button style={btnPri} onClick={() => { setForm(vuoto()); setErr(''); setAperto(true); }}>+ NUOVO RIMBORSO</button>}
      </div>
      {msg && <div style={{ background:'#3DBE7A22', color:'#3DBE7A', borderRadius:'8px', padding:'10px 14px', marginBottom:'14px', fontSize:'var(--font-size-sm)' }}>{msg}</div>}

      <div style={{ ...card, marginBottom:'18px' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', gap:'12px', flexWrap:'wrap' }}>
          <div>
            <span style={{ ...labelS, marginBottom:'2px' }}>{MESI[form.mese - 1].toUpperCase()} {form.anno} · DISPONIBILE</span>
            <div style={{ fontFamily:"'Barlow Condensed'", fontSize:'32px', fontWeight:'800', color: eccede ? '#EF5350' : 'var(--text)' }}>{eur(Math.max(residuo - (aperto ? importoNum : 0), 0))}</div>
          </div>
          <span style={{ color:'var(--text-dim)', fontSize:'var(--font-size-sm)' }}>tetto mensile {eur(tetto)}</span>
        </div>
        <div style={{ height:'10px', borderRadius:'5px', background:'var(--bg-input)', margin:'10px 0 8px', display:'flex', overflow:'hidden' }}>
          <i style={{ width:pct(dati.approvato), background:'#3DBE7A' }}/>
          <i style={{ width:pct(dati.in_attesa - propria), background:'#F5A524' }}/>
          {aperto && <i style={{ width:pct(Math.min(importoNum, Math.max(residuo, 0))), background:'#F4600C' }}/>}
        </div>
        <div style={{ display:'flex', gap:'16px', flexWrap:'wrap', color:'var(--text-dim)', fontSize:'var(--font-size-xs)' }}>
          <span><b style={{ color:'#3DBE7A' }}>■</b> Approvato {eur(dati.approvato)}</span>
          <span><b style={{ color:'#F5A524' }}>■</b> In attesa {eur(dati.in_attesa)}</span>
          {aperto && <span><b style={{ color:'#F4600C' }}>■</b> Questa richiesta {eur(importoNum)}</span>}
        </div>
      </div>

      {aperto && (
        <form onSubmit={invia} style={{ ...card, marginBottom:'18px' }}>
          <span style={{ ...labelS, marginBottom:'14px' }}>{form.id ? 'CORREGGI RICHIESTA' : 'NUOVO RIMBORSO'}</span>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap:'14px', marginBottom:'14px' }}>
            <div><label style={labelS} htmlFor="rb-mese">MESE DI COMPETENZA</label>
              <select id="rb-mese" style={inputS} value={`${form.anno}-${form.mese}`} onChange={e => { const [a, m] = e.target.value.split('-').map(Number); setForm(s => ({ ...s, anno:a, mese:m })); }}>
                {mesiOpzioni.map(o => <option key={`${o.anno}-${o.mese}`} value={`${o.anno}-${o.mese}`}>{MESI[o.mese - 1]} {o.anno}</option>)}
                {!mesiOpzioni.some(o => o.anno === form.anno && o.mese === form.mese) && <option value={`${form.anno}-${form.mese}`}>{MESI[form.mese - 1]} {form.anno}</option>}
              </select></div>
            <div><label style={labelS} htmlFor="rb-data">DATA DELLA SPESA</label>
              <input id="rb-data" style={inputS} type="date" required value={form.data_spesa} onChange={e => setForm(s => ({ ...s, data_spesa: e.target.value }))}/></div>
            <div><label style={labelS} htmlFor="rb-cat">TIPO DI SPESA</label>
              <select id="rb-cat" style={inputS} required value={form.categoria} onChange={e => setForm(s => ({ ...s, categoria: e.target.value }))}>
                <option value="">Seleziona…</option>{dati.categorie.map(c => <option key={c}>{c}</option>)}</select></div>
            <div><label style={labelS} htmlFor="rb-imp">IMPORTO (€)</label>
              <input id="rb-imp" style={inputS} inputMode="decimal" required value={form.importo} onChange={e => setForm(s => ({ ...s, importo: e.target.value }))} placeholder="0,00"/></div>
          </div>
          <div style={{ marginBottom:'6px', fontSize:'var(--font-size-xs)', color: eccede ? '#EF5350' : dopo < 30 && importoNum > 0 ? '#F5A524' : 'var(--text-dim)' }}>
            {importoNum <= 0 ? `Per ${MESI[form.mese - 1]} puoi ancora richiedere ${eur(residuo)}.`
              : eccede ? `Supera il tetto mensile di ${eur(-dopo)}: riduci l'importo o scegli un altro mese.`
              : `Rientra nel tetto: dopo questa richiesta ti restano ${eur(dopo)}.`}
          </div>
          <div style={{ margin:'14px 0' }}><label style={labelS} htmlFor="rb-det">DETTAGLIO</label>
            <textarea id="rb-det" style={{ ...inputS, minHeight:'70px', resize:'vertical' }} required maxLength={500} value={form.dettaglio} onChange={e => setForm(s => ({ ...s, dettaglio: e.target.value }))} placeholder="Es. benzina e pedaggio per la trasferta al torneo di Rimini"/></div>
          <div style={{ marginBottom:'14px' }}><label style={labelS} htmlFor="rb-file">GIUSTIFICATIVO — UN SOLO FILE</label>
            <input id="rb-file" ref={fileRef} type="file" accept="application/pdf,image/jpeg,image/png" style={{ ...inputS, padding:'8px' }} onChange={e => scegliFile(e.target.files[0])}/>
            <div style={{ fontSize:'var(--font-size-xs)', color:'var(--text-dim)', marginTop:'6px' }}>
              PDF, JPG o PNG, massimo {dati.max_mb} MB. Hai più scontrini? Uniscili in un unico PDF prima di caricarlo.
              {form.id && !form.file && ' Se non carichi nulla resta il file già inviato.'}</div></div>
          {err && <div style={{ color:'#EF5350', fontSize:'var(--font-size-sm)', marginBottom:'12px' }}>{err}</div>}
          <div style={{ display:'flex', gap:'10px' }}>
            <button type="submit" style={{ ...btnPri, opacity: invio || eccede ? .5 : 1 }} disabled={invio || eccede}>{invio ? 'INVIO…' : form.id ? 'RINVIA RICHIESTA' : 'INVIA RICHIESTA'}</button>
            <button type="button" style={btnSec} onClick={() => { setAperto(false); setForm(vuoto()); setErr(''); }}>ANNULLA</button>
          </div>
        </form>
      )}

      <div style={card}>
        <span style={{ ...labelS, marginBottom:'8px' }}>STORICO</span>
        {dati.richieste.length === 0 ? <div style={{ color:'var(--text-dim)', fontSize:'var(--font-size-sm)' }}>Nessuna richiesta ancora. Usa "Nuovo rimborso" per inviarne una.</div> : (
          <div style={{ overflowX:'auto' }}><table style={{ width:'100%', borderCollapse:'collapse', minWidth:'620px' }}>
            <thead><tr><th style={th}>N.</th><th style={th}>SPESA</th><th style={{ ...th, textAlign:'right' }}>IMPORTO</th><th style={th}>STATO</th><th style={th}></th></tr></thead>
            <tbody>{dati.richieste.map(r => (
              <tr key={r.id}>
                <td style={td}><b>{r.numero}</b><div style={{ color:'var(--text-dim)', fontSize:'var(--font-size-xs)' }}>{MESI[r.mese - 1]} {r.anno}</div></td>
                <td style={td}>{r.categoria} · {dataIt(r.data_spesa)}<div style={{ color:'var(--text-dim)', fontSize:'var(--font-size-xs)' }}>{r.dettaglio}</div>
                  {r.stato === 'RIFIUTATO' && <div style={{ color:'#EF5350', fontSize:'var(--font-size-xs)', marginTop:'3px' }}>Motivo: {r.motivo_rifiuto}</div>}</td>
                <td style={{ ...td, textAlign:'right', fontVariantNumeric:'tabular-nums' }}>{eur(r.importo)}</td>
                <td style={td}><span style={pillS(r.stato)}>{statoLabel(r.stato)}</span></td>
                <td style={{ ...td, whiteSpace:'nowrap', textAlign:'right' }}>
                  <button style={{ ...btnSec, padding:'5px 10px' }} onClick={() => apriPdf(`/rimborsi/me/${r.id}/pdf`)}>PDF</button>{' '}
                  {r.stato === 'RIFIUTATO' && <button style={{ ...btnPri, padding:'6px 10px' }} onClick={() => modifica(r)}>CORREGGI</button>}{' '}
                  {r.stato !== 'APPROVATO' && <button style={{ ...btnSec, padding:'5px 10px' }} onClick={() => ritira(r)}>RITIRA</button>}
                </td>
              </tr>))}</tbody>
          </table></div>)}
      </div>
    </div>
  );
}
